import Component from '../vendor/Component'
import Helpers from '../qf/Helpers'

export default class Header extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._lastScrollY = 0
    this._currentScrollY = window.scrollY
    this._currentDirection = 'down'
    this._header = document.querySelector(this._options.header)
    this._headerHeight = this._header.getBoundingClientRect().height
  }

  mount() {
    this._assignVariables()
    this._doScrollCalculations()

    window.addEventListener('scroll', e => {
      this._assignVariables()
      this._doScrollCalculations()
    }, { passive: true })
  }

  _doScrollCalculations() {
    if (this._currentDirection === 'down' && this._currentScrollY >= this._headerHeight) {
      this._header.classList.add('not-visible')
      Helpers.nextFrame(e => {
        this._header.classList.add('fixed')
      })

      document.body.classList.remove('header--shown')
    }

    if (this._currentDirection === 'up') {
      this._header.classList.remove('not-visible')
      document.body.classList.add('header--shown')
    }

    if (this._currentScrollY === 0) {
      this._header.classList.remove('fixed')
      document.body.classList.remove('header--shown')
    }

    if (document.body.classList.contains('no-scroll')) {
      this._header.classList.remove('not-visible')
      this._header.classList.add('fixed')
      document.body.classList.add('header--shown')
    }
  }

  _assignVariables() {
    this._currentScrollY = window.scrollY
    this._currentDirection = this._currentScrollY > this._lastScrollY ? 'down' : 'up'
    this._lastScrollY = window.scrollY
  }
}
